<template>
	<div>
		<botao-voltar label-voltar="Voltar para Ata" :nome-rota-anterior="rotaListagem"></botao-voltar>
		<az-container>
			<div class="cabecalho-customizado rounded-t">
				<div class="d-flex flow-row justify-start align-content-stretch">
					<div class="infoCabecalho">
						<span class="label">N° Aditivo/Apostila</span>
						<span class="item-text">{{ numero }}</span>
					</div>
					<div class="infoCabecalho">
						<span class="label">Criação</span>
						<span class="item-text">{{ dataCriacao }}</span>
					</div>
					<div class="infoCabecalho">
						<span class="label">Usuário</span>
						<span class="item-text">{{ usuario }}</span>
					</div>
					<div class="infoCabecalho">
						<span class="label">Situação</span>
						<span class="item-text">{{ situacao }}</span>
					</div>
					<div class="infoCabecalho">
						<span class="label">Nº Ata</span>
						<span class="item-text">{{ numeroAta }}</span>
					</div>
					<div class="infoCabecalho">
						<span class="label">Vigência</span>
						<span class="item-text">{{ VigenciaFilter(inicioVigencia,fimVigencia) }}</span>
					</div>
				</div>
			</div>
			<stepper-aditivo-apostila
				class="px-2"
				:steps="etapas"
				:step-atual="step"
				:editable="existemDadosSalvos"
				@step-alterado="verificaStep"
			>
				<template #step-1>
					<primeira-etapa-aditivo-apostila @foi-salvo="alteraExistemDadosSalvos">
					</primeira-etapa-aditivo-apostila>
				</template>
				<template #step-2>
					<segunda-etapa-aditivo-apostila></segunda-etapa-aditivo-apostila>
				</template>
			</stepper-aditivo-apostila>
		</az-container>
	</div>
</template>
<script>
import BotaoVoltar from '@/views/components/BotaoVoltar.vue'
import StepperAditivoApostila from './stepper-aditivo-apostila/StepperAditivoApostila.vue'
import { routesNames } from '@/core/constants'
import PrimeiraEtapaAditivoApostila from './primeira-etapa/PrimeiraEtapaAditivoApostila.vue'
import SegundaEtapaAditivoApostila from './segunda-etapa/SegundaEtapaAditivoApostila.vue'
import { mapState } from 'vuex'
import formatDataFilter from "@/views/filters/format-data-filter";
import VigenciaFilter from "../../../../filters/vigencia-filter";

export default {
	name: 'aditivo-apostila-view',
	components: { SegundaEtapaAditivoApostila, PrimeiraEtapaAditivoApostila, StepperAditivoApostila, BotaoVoltar },
	data() {
		return {
			etapas: [
				{ num: 1, nome: 'Dados Gerais / Itens' },
				{ num: 2, nome: 'Documentos' },
			],
			step: 1,
			rotaListagem: routesNames.ATA.ATA_ACESSAR_GESTAO_ATA_VIEW,
			existemDadosSalvos: false,
		}
	},
	computed: {
		...mapState({
			aditivoApostila: (state) => state.aditivoApostila,
		}),
		numero() {
			return this.validaAditivoApostila(this.aditivoApostila.cabecalho.numeroAditivoApostila || 'Não Informado')
		},
		dataCriacao() {
			return this.validaAditivoApostila(formatDataFilter(this.aditivoApostila.cabecalho.dataCriacao))
		},
		usuario() {
			return this.validaAditivoApostila(this.aditivoApostila.cabecalho.usuario)
		},
		situacao() {
			return this.validaAditivoApostila(this.aditivoApostila.isEfetivado ? 'Efetivado' : 'Em Elaboração')
		},
		inicioVigencia() {
			return this.validaAditivoApostila(this.aditivoApostila.cabecalho.inicioVigencia)
		},
		fimVigencia() {
			return this.validaAditivoApostila(this.aditivoApostila.cabecalho.fimVigencia)
		},
		numeroAta() {
			return this.validaAditivoApostila(this.aditivoApostila.cabecalho.numeroAta)
		},
	},
	methods: {
		VigenciaFilter,
		verificaStep(stepAtual) {
			this.step = stepAtual
		},
		alteraExistemDadosSalvos(valor) {
			this.existemDadosSalvos = valor
		},
		validaAditivoApostila(value) {
			return this.aditivoApostila.cabecalho.dataCriacao ? value : ''
		},
	},
}
</script>
<style lang="stylus" scoped>
.cabecalho-customizado
	background-color var(--v-primary-base)
	display flex
	flex-direction row
	justify-content space-between
	color #FFF !important
	height 70px
	padding: .8rem 0.5rem !important;

.infoCabecalho
	display flex
	flex-direction column
	justify-items space-evenly
	justify-content space-evenly
	margin 0 10px

.label
	font-weight bold !important
	font-size 0.75em !important
	color white !important

.item-text
	display inline-flex !important
	font-size .8em !important
	color white !important
</style>
